import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  // mode: "history",
  // base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "privacy",
      component: () => import("./Privacy.vue"),
    },
    {
      path: "/other",
      name: "other",
      component: () => import("./other.vue"),
    },
  ],
});
